import Event from './event'
import eventFragment from './event.fragment'

export { eventFragment }

export default Event
